const slugify = require('slugify')
const createPath=  (text) => slugify(text, { lower: true }).replace(/:/g, '-')

module.exports = {
  createPath
}